export * as CommonText from './common-text';
export * as Dictionary from './Dictionary';
export * as FileSystem from './FileSystem';
export * as Timer from './timer';
export * as Icon from './Icon';
export * as Json from './Json';
export { default as Locale, measurementSystems as localeMeasurementSystems } from './Locale';
export { default as Logger } from './Logger';
export * as Math from './Math';
export * as Restrictions from './Restrictions';
export * as Uuid from './Uuid';
export * as Chemistry from './Chemistry';
export * as Object from './Object';
export * from './throttle';
export * from "./Error";

export function isSet(value: any): boolean {
    if (typeof value === "undefined") return false;
    if (value === null) return false;
    if (value === "") return false;
    return true;
}
